import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
  Tab,
  Tabs,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { UText } from "@/components/index"

import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import { SliderBox } from "./components/SliderBox"
import { globalEvents, GlobalEvents, wasmModule } from "@/gluelayer"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import { setOpenUndercutPreview } from "@/UDTreat/udTreatSlice"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{
        visibility: value === index ? "visible" : "hidden",
        height: value === index ? "auto" : 0,
      }}
    >
      {children}
    </div>
  )
}
export const UnderCutWindow = () => {
  const dispatch = useAppDispatch()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { curArch } = useAppSelector((state: RootState) => state.udTreatService)
  const [tabVal, setTabVal] = useState<number>(0)

  const handleChange = (event: React.SyntheticEvent, tabIndex: number) => {
    setTabVal(tabIndex)
  }

  useEffect(() => {
    const printModule = wasmModule.moduleManager.GetModulePrintSelection()
    if (!printModule) return

    printModule.ShowUndercutFillingHandle &&
      printModule.ShowUndercutFillingHandle(
        curArch == "up" ? 0 : 1,
        tabVal === 2 ? true : false,
      )
  }, [curArch, tabVal])

  useEffect(() => {
    globalEvents.on(GlobalEvents.ON_UBRefreshUICBStr, () => {
      setTabVal(2)
    })
  }, [])

  return (
    <Box
      sx={{
        width: "40%",
        height: "412px",
        position: "absolute",
        bottom: "0",
        padding: "16px 16px 24px 48px",
        background: "#fff",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "calc(100% - 16px)",
          padding: "6px 16px",
          borderRadius: "4px",
          background: "rgba(255, 255, 255, 0.40)",
          left: "8px",
          top: "-56px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <InfoOutlinedIcon sx={{ color: "#fff" }} />
        <Box
          sx={{
            color: "var(--info-contrast, #FFF)",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "143%",
            letterSpacing: "0.15px",
            marginLeft: "12px",
            padding: "8px 0",
          }}
        >{`Adjustments will apply to all the stages selected for output.`}</Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <UText variant={"h6"}>{`Digital Fill Preview`}</UText>
        <Button
          onClick={() => {
            // GoToOrigin3DScene
            const printMoudle =
              wasmModule.moduleManager.GetModulePrintSelection()
            if (printMoudle) {
              printMoudle.ApplyInPreview()
              printMoudle.GoToOrigin3DScene()
              dispatch(setOpenUndercutPreview(false))
            }
          }}
          variant="contained"
          sx={{ height: "30px", padding: "4px 10px" }}
          endIcon={<ArrowForwardIosIcon sx={{ fontSize: "14px!important" }} />}
        >{`Back`}</Button>
      </Box>
      <Tabs
        value={tabVal}
        onChange={handleChange}
        aria-label="basic tabs example"
        className={"tabsBox"}
        sx={{
          minHeight: "40px",
          "& .MuiTab-root": {
            padding: "0px 16px",
            fontSize: "14px",
            fontWeight: "500",
            minWidth: "unset",
            maxWidth: "unset",
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            minHeight: "40px",
          },
        }}
      >
        <Tab label="Anterior" />
        <Tab label="Posterior" />
        <Tab label="Individual" />
      </Tabs>

      <Box>
        <CustomTabPanel value={tabVal} index={0}>
          <SliderBox
            tabIndex={0}
            curTabIndex={tabVal}
            archType={curArch == "up" ? 0 : 1}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={1}>
          <SliderBox
            tabIndex={1}
            curTabIndex={tabVal}
            archType={curArch == "up" ? 0 : 1}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={2}>
          <SliderBox
            tabIndex={2}
            curTabIndex={tabVal}
            archType={curArch == "up" ? 0 : 1}
          />
        </CustomTabPanel>
      </Box>
      {/* <Button
        onClick={() => {
          const modulePrintSelection =
            wasmModule.moduleManager.GetModulePrintSelection()
          if (!modulePrintSelection) return

          modulePrintSelection.GoToOrigin3DScene()
          dispatch(setOpenUndercutPreview(false))
        }}
        variant="contained"
        sx={{
          position: "absolute",
          right: 80,
          bottom: 10,
          padding: "6px 16px",
          width: "150px",
          height: "36px",
        }}
      >{`APPLY`}</Button> */}
    </Box>
  )
}
